import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Normala",
  "description": "",
  "published": "2007-01-10T00:00:00.000Z",
  "redirect_from": ["/blog/normala/swizec/326"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Kot je normalno pri popravljanju hroscev je trajalo dlje od pricakovanega. V tem trenutku je stran posodobljena na pravo verzijo in ima dodane vse pricakovane dodatke. Z izjemo nekaterih zanimiv hroscev (npr. zakaj komentarji delujejo samo pri stripih) in nekaterih jezikovnih nastavitev za slovenscino deluje vse po pricakovanjih. Vsa vsebina bo dodana v kratkem.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      